import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Fallback to emoji if image fails to load
const FooterLogoComponent = () => {
  const [imageError, setImageError] = useState(false);
  
  if (imageError) {
    return <span style={{ fontSize: '1.2rem' }}>🧠</span>;
  }
  
  return (
    <img 
      src="/images/Logo.png" 
      alt="MindXchange Logo" 
      className="footer-logo-image" 
      onError={() => setImageError(true)}
    />
  );
};

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div>
          <h4><FooterLogoComponent /> </h4>
          <p>Inspiring innovation through technology solutions.</p>
        </div>
        <div>
          <h4>Explore</h4>
          <p><Link to="/about">About Us</Link></p>
          <p><Link to="/services">Services</Link></p>
          <p><Link to="/faq">FAQ</Link></p>
          <p><Link to="/contact">Contact</Link></p>
        </div>
        <div>
          <h4>Contact Us</h4>
          <p>+1 708 912 8561</p>
          <p>sales@mindxchangeusa.com</p>
          <p>1931 West Broad Street Ste 204A</p>
          <p>Cedar City UT 84720</p>
        </div>
      </div>
      <div style={{ textAlign: 'center', marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <p>&copy; 2025 MindXchange. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 